import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import * as XLSX from "xlsx";

export const usePurchaseOrder = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [menu, setMenu] = useState("purchase-order");
  const [popUpBuatPo, setPopUpBuatPo] = useState(false);

  const [listItemChecklist, setListItemChecklist] = useState([]);

  const [vendorPick, setVendorPick] = useState();
  const [tglPoPick, setTglPoPick] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );
  const [deliveryTime, setDeliveryTime] = useState();
  const [termOfPayment, setTermOfPayment] = useState(
    "30 H SETELAH BARANG DITERIMA"
  );
  const [overallDiscount, setOverallDiscount] = useState();
  const [keteranganPo, setKeteranganPo] = useState();

  const [listVendor, setListVendor] = useState([]);

  const [subMenu, setSubMenu] = useState("Open");

  const [popUpNewPo, setPopUpNewPo] = useState(false);
  const [newJumlah, setNewJumlah] = useState();
  const [newSatuan, setNewSatuan] = useState();

  const [isBarangSudahAda, setIsBarangSudahAda] = useState(false);
  const [dataListNama, setDataListNama] = useState();
  const [dataPerusahaan, setDataPerusahaan] = useState();
  const [subTitleNewPo, setSubTitleNewPo] = useState([{ desc: "", qty: "" }]);
  const [produkNewPo, setProdukNewPo] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [keteranganNewPo, setKeteranganNewPo] = useState();
  const [checklistPpn, setChecklistPpn] = useState(false);
  const [listPoPurchasing, setListPoPurchasing] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);

  const [search, setSearch] = useState();
  const [searchData, setSearchData] = useState(listPoPurchasing || []);
  const [lastData, setLastData] = useState();

  const [popUpDetail, setPopUpDetail] = useState(false);
  const [pickDataDetail, setPickDataDetail] = useState();

  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  const [popUpDetailPo, setPopUpDetailPo] = useState(false);

  const [popUpCariPo, setPopUpCariPo] = useState(false);

  const [filterBulanDari, setFilterBulanDari] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahunDari, setFilterTahunDari] = useState(
    moment().utcOffset("+0700").year()
  );
  const [filterBulanSampai, setFilterBulanSampai] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahunSampai, setFilterTahunSampai] = useState(
    moment().utcOffset("+0700").year()
  );

  const [itemCari, setItemCari] = useState();
  const [listCariData, setListCariData] = useState();

  const [popUpEditOpen, setPopUpEditOpen] = useState(false);
  const [popUpEditPo, setPopUpEditPo] = useState(false);

  const [editDataPo, setEditDataPo] = useState({
    tim: "",
    formId: "",
    satuan: "",
    id: "",
    item: "",
    jumlah: "",
    subTitle: [{ desc: "", qty: "" }],
    keterangan: "",
    timestamp: "",
  });

  const [editPoData, setEditPoData] = useState([]);

  const [editPoHeader, setEditPoHeader] = useState({
    vendorId: "",
    vendor: "",
    datePo: "",
    deliveryTime: "",
    termOfPayment: "",
    keteranganPo: "",
    overallDiscount: 0,
    noPo: "",
  });

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getVendor`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setListVendor,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListNamaBpb`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataListNama,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getDataPerusahaan`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataPerusahaan,
      ""
    );
  }, []);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListPoPurchasing`,
      {
        tim: dataUser.tim,
        type: subMenu,
        filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
      },
      dataUser.auth,
      setListPoPurchasing,
      ""
    );
    setIsRefresh(false);
  }, [subMenu, isRefresh, filterBulan, filterTahun]);

  useEffect(() => {
    setSearchData(listPoPurchasing);
  }, [listPoPurchasing]);

  useEffect(() => {
    const getLastData = () => {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getLastDataPo`,
        {
          tim: dataUser.tim,
          filterDate: moment(tglPoPick).utcOffset("+0700").format("YYYY-MM"),
          dataPick: listItemChecklist,
        },
        dataUser.auth,
        setLastData,
        ""
      );
    };

    getLastData();

    const interval = setInterval(() => {
      getLastData();
    }, 30000);

    return () => clearInterval(interval);
  }, [popUpBuatPo, tglPoPick, subMenu, isRefresh]);

  useEffect(() => {
    if (itemCari) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getCariRiwayatPo`,
        {
          tim: dataUser.tim,
          data: itemCari,
          filterBulanDari: filterBulanDari,
          filterTahunDari: filterTahunDari,
          filterBulanSampai: filterBulanSampai,
          filterTahunSampai: filterTahunSampai,
        },
        dataUser.auth,
        setListCariData,
        ""
      );
    }
  }, [
    itemCari,
    filterBulanDari,
    filterTahunDari,
    filterBulanSampai,
    filterTahunSampai,
  ]);

  const handleChangeChecklistBuatPo = (index, event, id) => {
    let data = [...searchData];
    if (data[index].formId !== id) {
      return;
    }
    const name = event.target.name;

    if (name === "isBuatPo") {
      data[index][name] = event.target.checked;
    }

    setListPoPurchasing(data);
  };

  const handleBuatPo = () => {
    const result = listPoPurchasing?.filter((item) => item.isBuatPo === true);

    if (result.length > 0) {
      setPopUpBuatPo(true);
      setListItemChecklist(result);
    }
  };

  const handleCloseBuatPo = () => {
    setPopUpBuatPo(false);
    setVendorPick();
    setListItemChecklist();
    setChecklistPpn(false);
    setLastData();
    setTglPoPick(moment().utcOffset("+0700").format("YYYY-MM-DD"));
    setDeliveryTime();
    setTermOfPayment("30 H SETELAH BARANG DITERIMA");
    setOverallDiscount();
    setKeteranganPo();
  };

  const handleCloseNewPo = () => {
    setKeteranganNewPo();
    setSubTitleNewPo([{ desc: "", qty: "" }]);
    setNewSatuan();
    setNewJumlah();
    setProdukNewPo();
    setIsBarangSudahAda(false);
  };

  const handleChangeBuatPo = (index, event, id) => {
    let data = [...listItemChecklist];

    if (data[index].id !== id) {
      return;
    }

    const name = event.target.name;

    const onlyNumber = event.target.value.replace(/\D/g, "");

    if (name === "jumlah") {
      data[index][name] = Number(onlyNumber);
    } else if (name === "price") {
      data[index][name] = Number(onlyNumber);
    } else if (name === "discount") {
      data[index][name] = Number(onlyNumber);
    } else if (name === "curr") {
      data[index][name] = event.target.value.toUpperCase();
    }

    setListItemChecklist(data);
  };

  const addFields = () => {
    let newfield = { desc: "", qty: "" };
    setSubTitleNewPo([...subTitleNewPo, newfield]);
  };

  const removeFields = () => {
    let data = [...subTitleNewPo];
    if (data.length > 1) {
      data.splice(data.length - 1);
      setSubTitleNewPo(data);
    }
  };

  const handleChangeSubtitle = (index, event) => {
    let data = [...subTitleNewPo];
    const name = event.target.name;

    data[index][name] = event.target.value.toUpperCase();

    setSubTitleNewPo(data);
  };

  useEffect(() => {
    setProdukNewPo();
  }, [isBarangSudahAda]);

  const handleChangeKirimNewPo = () => {
    if (produkNewPo && newJumlah && newSatuan) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/newPoPurchasing`,
        {
          tim: dataUser.tim,
          satuan: newSatuan,
          id: isBarangSudahAda ? produkNewPo.id : "",
          item: isBarangSudahAda ? produkNewPo.value : produkNewPo,
          jumlah: newJumlah,
          subTitle: subTitleNewPo,
          keterangan: keteranganNewPo,
          isBarangSudahAda: isBarangSudahAda,
        },
        dataUser.auth,
        "",
        ""
      );

      setTimeout(() => {
        handleCloseNewPo();
        setIsDisabled(false);
        setPopUpNewPo(false);
        setIsRefresh(true);
      }, 300);
    } else {
      setIsDisabled(false);
    }
  };

  const handleKirimBuatPo = () => {
    const isValid = listItemChecklist.every((item) => {
      return Number(item.jumlah) > 0 && Number(item.price) > 0;
    });

    const selectedVendor = listVendor?.find((v) => v.id === vendorPick?.id);

    if (isValid && vendorPick && deliveryTime && termOfPayment) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/createPoPurchasing`,
        {
          tim: dataUser.tim,
          data: listItemChecklist,
          vendorId: vendorPick,
          vendor: selectedVendor.name,
          deliveryTime: deliveryTime,
          termOfPayment: termOfPayment,
          overallDiscount: Number(overallDiscount),
          keterangan: keteranganPo,
          noPo: lastData.lastNoPo,
          datePo: tglPoPick,
          checklistPpn: checklistPpn,
          createdBy: dataUser.name,
        },
        dataUser.auth,
        "",
        ""
      );
      setTimeout(() => {
        setIsRefresh(true);
        setIsDisabled(false);
        setPopUpBuatPo(false);
        setLastData();
        handleCloseBuatPo();
      }, 300);
    } else {
      setIsDisabled(false);
    }
  };

  const fields = ["vendor", "noPo", "item"];

  const handleSearch = (keyword) => {
    if (!keyword || keyword.trim() === "") {
      setSearchData(listPoPurchasing);
      return;
    }

    const lowerKeyword = keyword.toLowerCase();

    const filtered = listPoPurchasing.filter((item) =>
      fields.some((field) => item[field]?.toLowerCase().includes(lowerKeyword))
    );

    setSearchData(filtered);
  };

  const handleDelete = (id) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deletePoPurchasing`,
      {
        formId: id,
      },
      dataUser.auth,
      setListVendor,
      ""
    );
    setTimeout(() => {
      setIsRefresh(true);
    }, 500);
  };

  const handleExportCariBarang = async () => {
    try {
      let data = (listCariData && listCariData) || [];

      const filteredDataExcel = await data.map((obj, index) => {
        return {
          "No.": index + 1,
          PO: obj.noPo,
          "Tgl PO": moment(obj.datePo).format("DD-MM-YYYY"),
          Item: obj.item,
          Jumlah: obj.jumlah,
          "Unit Price": obj.price,
          "Discount (%)": obj.discount,
        };
      });

      const workSheet = XLSX.utils.json_to_sheet(
        filteredDataExcel && filteredDataExcel
      );

      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 15 },
        { wch: 11 },
        { wch: 51 },
        { wch: 11 },
        { wch: 14 },
        { wch: 11 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "PO");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(
        workBook,
        `Riwayat Pembelian ${itemCari.label} ${filterBulanDari}-${filterTahunDari} s/d ${filterBulanSampai}-${filterTahunSampai}.xlsx`
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (pickDataDetail) {
      setEditDataPo({
        tim: pickDataDetail?.tim || "",
        formId: pickDataDetail?.formId || "",
        satuan: pickDataDetail?.satuan || "",
        id: pickDataDetail?.id || "",
        item: pickDataDetail?.item || "",
        jumlah: pickDataDetail?.jumlah || "",
        subTitle: pickDataDetail?.subTitle?.length
          ? pickDataDetail?.subTitle
          : [{ desc: "", qty: "" }],
        keterangan: pickDataDetail?.keterangan || "",
        timestamp: pickDataDetail?.timestamp || "",
      });
    }
  }, [pickDataDetail]);

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;

    setEditDataPo((prev) => ({
      ...prev,
      [name]: name === "keterangan" ? value.toUpperCase() : value,
    }));
  };

  const handleChangeProdukEditPo = (value) => {
    setProdukNewPo(value);

    setEditDataPo((prev) => ({
      ...prev,
      item: value?.label || "",
      id: value?.value || "",
    }));
  };

  const handleChangeSubtitleEditPo = (index, e) => {
    const { name, value } = e.target;

    const updated = [...editDataPo.subTitle];

    updated[index][name] = value.toUpperCase();

    setEditDataPo((prev) => ({
      ...prev,
      subTitle: updated,
    }));
  };

  const addFieldsEditPo = () => {
    setEditDataPo((prev) => ({
      ...prev,
      subTitle: [...prev.subTitle, { desc: "", qty: "" }],
    }));
  };

  const removeFieldsEditPo = () => {
    if (editDataPo.subTitle.length === 1) return;

    const updated = [...editDataPo.subTitle];
    updated.pop();

    setEditDataPo((prev) => ({
      ...prev,
      subTitle: updated,
    }));
  };

  const handleEditPo = async (type) => {
    try {
      setIsDisabled(true);

      const payload = {
        ...editDataPo,
      };

      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editPoPurchasing`,
        {
          data: payload,
          type: type,
        },
        dataUser.auth,
        "",
        ""
      );
      setTimeout(() => {
        setIsRefresh(true);
        setPopUpEditOpen(false);
        setPickDataDetail();
      }, 500);

      setIsDisabled(false);
    } catch (err) {
      console.log(err);
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    if (pickDataDetail?.length > 0) {
      setEditPoData(pickDataDetail);

      setEditPoHeader({
        vendorId: pickDataDetail[0]?.vendorId || "",
        vendor: pickDataDetail[0]?.vendor || "",
        datePo: pickDataDetail[0]?.datePo || "",
        deliveryTime: pickDataDetail[0]?.deliveryTime || "",
        termOfPayment: pickDataDetail[0]?.termOfPayment || "",
        keteranganPo: pickDataDetail[0]?.keteranganPo || "",
        overallDiscount: pickDataDetail[0]?.overallDiscount || 0,
        noPo: pickDataDetail[0]?.noPo || "",
      });
    }
  }, [pickDataDetail]);

  const handleChangeEditPo = (index, e, id) => {
    const { name, value } = e.target;

    const updated = [...editPoData];

    let finalValue = value;

    if (name === "jumlah" || name === "price" || name === "discount") {
      finalValue = value.replace(/\./g, "");
    }

    updated[index] = {
      ...updated[index],
      [name]: name === "keterangan" ? finalValue.toUpperCase() : finalValue,
    };

    setEditPoData(updated);
  };

  const handleChangeHeaderEditPo = (e) => {
    const { name, value } = e.target;

    setEditPoHeader((prev) => ({
      ...prev,
      [name]:
        name === "deliveryTime" ||
        name === "termOfPayment" ||
        name === "keteranganPo"
          ? value.toUpperCase()
          : value,
    }));
  };

  const handleSubmitEditPo = async (type) => {
    try {
      setIsDisabled(true);

      const detailOnly = editPoData.map((item) => ({
        formId: item.formId,
        tim: item.tim,
        id: item.id,
        item: item.item,
        jumlah: item.jumlah,
        satuan: item.satuan,
        subTitle: item.subTitle,
        keterangan: item.keterangan,
        curr: item.curr,
        price: item.price,
        discount: item.discount,
        timestamp: item.timestamp,
      }));

      const payload = {
        header: {
          vendorId: editPoHeader.vendorId,
          datePo: editPoHeader.datePo,
          deliveryTime: editPoHeader.deliveryTime,
          termOfPayment: editPoHeader.termOfPayment,
          overallDiscount: Number(editPoHeader.overallDiscount || 0),
          keteranganPo: editPoHeader.keteranganPo,
          noPo: editPoHeader.noPo,
        },

        detail: detailOnly,
      };

      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editPoPurchasing`,
        {
          ...payload,
          type: type,
        },
        dataUser.auth,
        "",
        ""
      );
      setTimeout(() => {
        setIsRefresh(true);
        setPopUpEditPo(false);
        setPickDataDetail();
      }, 500);

      setIsDisabled(false);
    } catch (err) {
      console.log(err);
      setIsDisabled(false);
    }
  };

  const constNamaBarang = dataListNama?.listNamaBarang || [];
  const constNamaJasa = dataListNama?.listNamaJasa || [];

  const mergeArray = [...constNamaBarang, ...constNamaJasa];

  return {
    menu,
    setMenu,
    dataUser,
    popUpBuatPo,
    setPopUpBuatPo,
    handleChangeChecklistBuatPo,
    handleBuatPo,
    listItemChecklist,
    handleCloseBuatPo,
    vendorPick,
    setVendorPick,
    tglPoPick,
    setTglPoPick,
    deliveryTime,
    setDeliveryTime,
    termOfPayment,
    setTermOfPayment,
    handleChangeBuatPo,
    subMenu,
    setSubMenu,
    listVendor,
    popUpNewPo,
    setPopUpNewPo,
    newJumlah,
    setNewJumlah,
    newSatuan,
    setNewSatuan,
    keteranganPo,
    setKeteranganPo,
    checklistPpn,
    setChecklistPpn,
    isBarangSudahAda,
    setIsBarangSudahAda,
    dataListNama,
    removeFields,
    subTitleNewPo,
    addFields,
    handleChangeSubtitle,
    produkNewPo,
    setProdukNewPo,
    handleChangeKirimNewPo,
    isDisabled,
    setIsDisabled,
    keteranganNewPo,
    setKeteranganNewPo,
    handleKirimBuatPo,
    search,
    setSearch,
    handleSearch,
    searchData,
    lastData,
    listPoPurchasing,
    popUpDetail,
    setPopUpDetail,
    pickDataDetail,
    setPickDataDetail,
    dataPerusahaan,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    overallDiscount,
    setOverallDiscount,
    popUpDetailPo,
    setPopUpDetailPo,
    handleDelete,
    setIsRefresh,
    popUpCariPo,
    setPopUpCariPo,
    filterBulanDari,
    setFilterBulanDari,
    filterTahunDari,
    setFilterTahunDari,
    filterBulanSampai,
    setFilterBulanSampai,
    filterTahunSampai,
    setFilterTahunSampai,
    itemCari,
    setItemCari,
    handleCloseNewPo,
    listCariData,
    setListCariData,
    handleExportCariBarang,
    popUpEditOpen,
    setPopUpEditOpen,
    popUpEditPo,
    setPopUpEditPo,
    handleChangeEdit,
    handleChangeProdukEditPo,
    handleChangeSubtitleEditPo,
    addFieldsEditPo,
    removeFieldsEditPo,
    editDataPo,
    setEditDataPo,
    handleEditPo,
    editPoHeader,
    setEditPoHeader,
    editPoData,
    setEditPoData,
    handleChangeEditPo,
    handleSubmitEditPo,
    handleChangeHeaderEditPo,
    mergeArray,
  };
};
